// Boiler Plate Imports
import React, { useEffect, useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import styled from "styled-components";
import {
  remove as removeNotification,
  add as addNotification,
} from "../../redux-store/notificationsSlice";
import { update as setBreadCrumbs } from "../../redux-store/breadCrumbsSlice";
import { update as updateUserProfile } from "../../redux-store/userSlice";
import API from "../../api";
import colors from "../../theme/colors";

// Conatiner Component Imports
import { Button, Card } from "@mui/material";
import BreadCrumbs from "../../components/Navigation/breadcrumbs";
import ModalComponent from "../../components/Modal";
import ConfirmForm from "../../components/Forms/confirmForm";
import TableHeader from "../../components/Page/tableHeader";

// Page Component Imports
import AdminUserForm from "../../components/Forms/adminUserForm";
import { FormatPhoneNumber } from "../../components/PhoneNumberInput";

import {
  TableComponent,
  ItemOnClickLink,
} from "../../components/Table/dataGridPro";
import { useNavigate } from "react-router-dom";

const ModalEditHeaderUserName = styled.span`
  color: ${colors.gray};
  margin-left: 5px;
`;

const PaddingWrapper = styled.div`
  padding: 0 15px 10px;
  @media (max-width: 1080px) {
    padding: 0 0px 10px;
  }
`;

const Table = React.memo(TableComponent);

const AdminUserContainer = () => {
  const userProfile = useSelector((state) => state.user);

  const [savingUser, setSavingUser] = useState(false);
  const [savingUserError, setSavingUserError] = useState(false);
  const [userTableRows, setUserTableRows] = useState([]);
  const [reloadData, setReloadData] = useState(false);

  const [openModal, setOpenModal] = useState(false);
  const [openDeactivateModal, setOpenDeactivateModal] = useState(false);
  const [openReactivateModal, setOpenReactivateModal] = useState(false);
  const [openEditUserModal, setOpenEditUserModal] = useState(false);
  const [currentUserEdit, setCurrentUserEdit] = useState({});

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const tableColumns = useMemo(
    () => [
      {
        headerName: "Name",
        field: "name",
        width: 180,
        valueGetter: (value, row) => {
          return row.name;
        },
        renderCell: ({ row }) => {
          return (
            <ItemOnClickLink onClick={() => handlers.editUserClick(row.id)}>
              {row.name}
            </ItemOnClickLink>
          );
        },
      },
      {
        headerName: "Type",
        field: "type",
        valueGetter: (value, row) => {
          if (row.type === "CUSTOMER") {
            return "ORGANIZATION"
          } else {
            return row.type;
          }
        },
      },
      {
        headerName: "Group",
        field: "group",
        valueGetter: (value, row) => {
          if (row.type === "CUSTOMER") {
            return row.organization.name;
          } else {
            return row.organizationId;
          }
        },
        renderCell: ({ row }) => {
          if (row.type === "CUSTOMER") {
            return (
              <ItemOnClickLink
                onClick={() => handlers.organizationClick(row.organization.id)}
              >
                {row.organization.name}
              </ItemOnClickLink>
            );
          } else {
            return row.organizationId;
          }
        },
      },
      {
        headerName: "Email Address",
        field: "email",
      },
      {
        headerName: "Phone Number",
        field: "phoneString",
      },
      {
        headerName: "Status",
        field: "status",
      },

      {
        headerName: "Role",
        field: "role",
        valueGetter: (value, row) => {
          if (row.type === "NETWORK") {
            return "NETWORK";
          } else {
            return row.role;
          }
        },
      },
      {
        headerName: "Date Created",
        field: "dateCreateObject",
        type: "dateTime",
      },
    ],
    [userTableRows]
  );

  useEffect(() => {
    //Set Bread Crumbs
    dispatch(
      setBreadCrumbs([
        {
          title: "Admin Users",
          link: "/admin/users",
        },
      ])
    );
  }, []);

  const dataLayer = {
    GetAdminUsers: async () => {
      const users = await API.User.UserGetAdmins();
      const userRows = users.map((user) => {
        return {
          ...user,
          name: `${user.firstName} ${user.lastName}`,
          status: (() => {
            if (user.deleted) {
              return "Deactivated";
            } else if (user.invitePending) {
              return "Invite Pending";
            } else {
              return "Active";
            }
          })(),
          dateCreateObject: new Date(user.created),
          phoneString: FormatPhoneNumber(user.phone),
        };
      });
      setUserTableRows(userRows);
      setReloadData(false);
      return userRows;
    },
    GetUserProfile: async () => {
      const userProfile = await API.User.UserGet();
      dispatch(updateUserProfile(userProfile));
    },
  };

  const handlers = {
    addUserClick: () => {
      navigate(`/admin/users/create`);
    },
    editUserClick: (userId) => {
      navigate(`/admin/users/${userId}/edit`);
    },
    organizationClick: (organizationId) => {
      navigate(`/${organizationId}/organization`);
    },
  };

  return (
    <>
      
      <PaddingWrapper>
        <Card>
          <TableHeader>
            <h2>Boreas Users</h2>
            <Button
              onClick={handlers.addUserClick}
              variant="contained"
              color="primary"
              size="large"
            >
              ADD USER
            </Button>
          </TableHeader>

          <Table
            columns={tableColumns}
            label={""}
            autoResizeColumns={true}
            isAdminView={true}
            reloadData={reloadData}
            placeholder="There are no users created yet"
            getRowsFunction={dataLayer.GetAdminUsers}
            initialState={{
              pinnedColumns: { left: ["name"] },
              sorting: {
                sortModel: [{ field: "name", sort: "asc" }],
              },
            }}
          />
        </Card>
      </PaddingWrapper>
    </>
  );
};

export default AdminUserContainer;
